import type { ReactNode } from 'react';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title: string;
  description?: string;
  right?: ReactNode;
  below?: ReactNode;
  className?: string;
}

export const PageHeader = ({ title, description, right, below, className }: PageHeaderProps) => (
  <header className={[styles.header, className].filter(Boolean).join(' ')}>
    <div className={styles.heading}>
      <h1>{title}</h1>
      {description && <p>{description}</p>}
    </div>
    {right && <div className={styles.actions}>{right}</div>}
    {below && <div className={styles.below}>{below}</div>}
  </header>
);

export default PageHeader;
